import { SwColumn, SwIntroduction, SwTitle } from '@kaa/ui-flanders/components';
import React, { ReactNode } from 'react';
import './PageHeaderIntro.style.scss';
import { ShiftBy } from '../shiftBy/ShiftBy';

type PageHeaderIntroProps = {
  title?: string;
  subTitle?: string;
  className?: string;
  introduction?: string | ReactNode;
  alert?: ReactNode;
};

export const PageHeaderIntro = ({
  title,
  subTitle,
  introduction,
  className,
}: PageHeaderIntroProps) => {
  return (
    <>
      {(title || introduction) && (
        <SwColumn width="10" widthS="12" className={className}>
          {title && (
            <SwTitle tagName="h1" className="vl-u-spacer--medium">
              {title}
            </SwTitle>
          )}
          {subTitle && (
            <ShiftBy y={-30}>
              <p>{subTitle}</p>
            </ShiftBy>
          )}
          {introduction && (
            <SwIntroduction tagName="p">{introduction}</SwIntroduction>
          )}
        </SwColumn>
      )}
    </>
  );
};
